import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/form-requests/{formRequestId}/update-to-current-version']['PUT'];

type Input = ThisApi['params'];
type Output = ThisApi['response'];

const updateNoodleFormRequestToCurrentVersion = async ({ formRequestId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/form-requests/{formRequestId}/update-to-current-version', { formRequestId });
  const response = await noodleApiClient.put(path);
  return response.data;
};

export default updateNoodleFormRequestToCurrentVersion;
